import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const isPrerendered = document.documentElement.getAttribute("data-prerendered") === "true";

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (isPrerendered) {
  // Build-time prerendered HTML — hydrate to attach event listeners
  ReactDOM.hydrateRoot(container, tree);
} else {
  // Dev mode or non-prerendered route — full client-side render
  ReactDOM.createRoot(container).render(tree);
}
